import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AuthRoutingModule } from "./auth-routing.module";
import { NeedPayComponent } from "./needpay/needpay.component";
import { PasswdChangeComponent } from "./passwd-change/passwd-change.component";
import { PasswdComponent } from "./passwd/passwd.component";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ButtonModule } from "primeng/button";
import { PasswordModule } from "primeng/password";
import { InputTextModule } from "primeng/inputtext";
import { QrCodeModule } from "ng-qrcode";
import { GtagService } from "../gtag/gtag.service";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { CargoInfoComponent } from "./cargo-info/cargo-info.component";
import { CardModule } from 'primeng/card';
import { MobileAppLoginComponent } from "./mobile-app-login/mobile-app-login.component";

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        CommonModule,
        AuthRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ButtonModule,
        InputTextModule,
        PasswordModule,
        CardModule,
        QrCodeModule, 
    ],
    declarations: [
        LoginComponent,
        RegisterComponent,
        PasswdComponent,
        PasswdChangeComponent,
        NeedPayComponent,
        MobileAppLoginComponent,
        CargoInfoComponent
    ],
    providers: [
        GtagService,
    ]
})
export class AuthModule { }
